module.exports = function(bootstrap) {
	// bootstrap.directive('paginatedRepeat', ["$compile", function($compile) {
	// 	return {
	// 		// transclude: true,
	// 		controller: [function() {
	// 			// Empty controller is necessary for inter-directive communication.
	// 		}],
	// 		link: function(scope, element, attrs, controller, transclude) { // Linking function is the proper place to modify DOM elements, or attach events
	// 			// transclude(scope, function(clone, innerScope) { // Transclude function, allows us to avoid usin ng-transclude which would add at least 1 extra <div> that we don't want.
	// 				// var n = $('<div data-ng-repeat="'+attrs.paginatedRepeat+'">'+$('<div></div>').append(clone).html()+'</div>');
	// 				// element.replaceWith($compile(n)(scope));
	// 				element.attr('data-ng-repeat', attrs.paginatedRepeat);
	// 				var a = $('<div>d</div>');
	// 				element.wrap(a);
	// 				element.after($('<div data-pagination-controls data-length="('+attrs.paginatedRepeat+').length" data-items-per-page="itemsPerPage" data-page="page">sdfds</div>'));
	// 				element.removeAttr('data-paginated-repeat');
	// 				$compile(a)(scope);
	// 			// });
	// 		}
	// 	}
	// }]);
	bootstrap.directive('drawer', [function() {
		return {
			controller: [function() {
				// Empty controller is necessary for inter-directive communication.
			}],
			link: function(scope, element, attrs, controller) { // Linking function is the proper place to modify DOM elements, or attach events
				element.addClass('drawer'); // element is our directives compiled template.  Adding a class to it.
				controller.targetName = attrs['drawer']; // Linking function gives us access to normalized attributes.  Grab the string value assigned to drawer directive and store it in our shared controller for use below.
				controller.targetName = controller.targetName || 'drawerOpen'; // If data-dawer was used without a value, make one up.
				scope.$watch(function() { // We need to watch for scope changes.
					return scope.$eval(controller.targetName); // scope.$eval evaluates an expression against the scope.  We want to monitor value passed in to the drawer directive, assigned above.
				}, function(v) { // Function that runs when the value changes
					if (v) { // If true, drawer is opened
						scope.$emit('drawerOpen'); // Emit an event upward so users can run code when drawers are opened
						element.addClass('drawerOpen'); // Add class
                        element.attr('aria-expanded',true);
					}
					else { // If false, drawer is closed
						scope.$emit('drawerClose'); // Emit an event upward so users can run code when drawers are closed
						element.removeClass('drawerOpen'); // Remove class
                        element.attr('aria-expanded',false);
					}
				});
				scope.$eval(controller.targetName + ' = !!' + controller.targetName); // !! is a shortcut for Boolean().  We want to make sure the scope has this value assigned right away.
			}
		};
	}]);
	bootstrap.directive('drawerHeader', [function() {
		return {
			require: '^drawer',	// Require parent element to have a drawer directive.  This allows controllers to be shared.
			transclude: true, // Transclusion necessary to allow the user of the directive to control the HTML tags for the drawer.  Otherwise, we would have to specify it in a template.
			controller: [function() {
				// Empty controller is necessary for inter-directive communication.
			}],
			link: function(scope, iElem, iAttrs, controller, transclude) { // Linking function is the proper place to modify DOM elements, or attach events
				iElem.on('click keypress', function(evt) { // On click event
                    var code = evt.charCode || evt.keyCode;
                    if (evt.type === 'click' || code === 13) {
						var expand = scope.$eval(controller.targetName);
						evt.currentTarget.children[0].setAttribute('aria-expanded', !expand);// check for value on original target
                        var skipOpen = $(evt.target).data('skip-open') || $(evt.target).closest('button').data('skip-open');  // check for value on original target
                        if (!(controller.animating || skipOpen)) { // If we're not already running an animation and click didn't originate from a control with data-skip-open
                            scope.$eval(controller.targetName + ' = !' + controller.targetName); // Swap the true/false value that represents the drawer being open or closed
                            scope.$apply(); // We have to manually apply the changes, since we're operating outside of angulars realm
                        }
                    }
				});
				transclude(scope, function(clone, innerScope) { // Transclude function, allows us to avoid usin ng-transclude which would add at least 1 extra <div> that we don't want.
					iElem.addClass('drawerHeader'); // iElem is our directives compiled template.  Adding a class to it.
					iElem.append('<button type="button" aria-label="Open Drawer"><span class="offscreen" >Open Drawer</span><span class="icon-black-single-arrow-down"></span><span class="icon-black-single-arrow-right"></span></button>'); // Appendng a button to it.
					iElem.append(clone); // clone is our element that had drawer-header on it.  Append it to our template.
					var seeMoreLabel = iAttrs.seeMoreLabel || 'See More';
                    iElem.append('<div class="drawerHeaderFooter"><button type="button">' + seeMoreLabel + '</button></div>'); // clone is our element that had drawer-header on it.  Append it to our template.
				});
			}
		};
	}]);
	bootstrap.directive('drawerBody', ["$animate", function($animate) {
		return {
			require: '^drawer',	// Require parent element to have a drawer directive.  This allows controllers to be shared.
			transclude: true, // Transclusion necessary to allow the user of the directive to control the HTML tags for the drawer.  Otherwise, we would have to specify it in a template.
			controller: [function() {
				// Empty controller is necessary for inter-directive communication.
			}],
			link: function(scope, iElem, iAttrs, controller, transclude) { // Linking function is the proper place to modify DOM elements, or attach events
				scope.$watch(function() { // We need to watch for scope changes.
					return scope.$eval(controller.targetName); // scope.$eval evaluates an expression against the scope.  We want to monitor value passed in to the drawer directive, assigned above.
				}, function(v) { // Function that runs when the value changes
					if (!controller.animating) { // If we're not already running an animation
						if (v) { // If true, open the drawer
							iElem.css({display: 'block'});
							$animate.removeClass(iElem, 'closed')['finally'](function() { // Call the animation to open the drawer, by removing the closed class.  Use the promise it returns to run a function
								controller.animating = false; // Promise is resolved/rejected.  Turn our animation flag off.
							});
						}
						else { // If false, close the drawer
							$animate.addClass(iElem, 'closed')['finally'](function() { // Call the animation to close the drawer, by adding the closed class.  Use the promise it returns to run a function
								controller.animating = false; // Promise is resolved/rejected.  Turn our animation flag off.
								iElem.css({display: 'none'});
							});
						}
					}
					controller.animating = true; // Turn our animation flag on
				});
				transclude(scope, function(clone, innerScope) { // Transclude function, allows us to avoid usin ng-transclude which would add at least 1 extra <div> that we don't want.
					iElem.addClass('drawerBody'); // iElem is our directives compiled template.  Adding a class to it.
					iElem.css({display: 'none'});
					iElem.addClass('slidedown closed'); // iElem is our empty template.  Add the slidedown animation class to it.
					iElem.append($('<div class="drawerBodyContainer"></div>').append(clone)); // clone is our element that had drawer-header on it.  Append it to our empty template.

                    var seeLessLabel = iAttrs.seeLessLabel || 'See Less';
                    var footerNode= $('<div class="drawerBodyFooter"><button type="button">' + seeLessLabel + '</button></div>'); // Create a new node for the close button

					iElem.append(footerNode); // Append it to the template
					footerNode.find('button').on('click', function() { // On click event
						if (!controller.animating) { // If we're not already running an animation

							// FIXME:  commented out the below line, it needs to be changed to only run on mobile, and/or detect when the element is still scrolled past.
							// UPDATE: This may not be needed now,, since slidedown animation moves the focus to just before the outside of the drawer.  If the focus is moved offscreen, it scrolls automatically
							// $('html, body').animate({scrollTop: $(document).scrollTop() - iElem.height()}, 1); // Cross broswer friendly way to control scroll top.  Duration of 1ms because we don't want flicker.
							scope.$eval(controller.targetName + ' = !' + controller.targetName); // Swap the true/false value that represents the drawer being open or closed
							scope.$apply(); // We have to manually apply the changes, since we're operating outside of angulars realm
						}
					});
				});
			}
		};
	}]);
};
